import Link from 'next/link'

import ProcessIconOne from '@/assets/svg/ProcessIconOne'
import ProcessIconThree from '@/assets/svg/ProcessIconThree'
import ProcessIconTwo from '@/assets/svg/ProcessIconTwo'
import useKva, { LANDING_PAGE_LENDING } from '@/hooks/useKVA'

const PROCESS_LIST = [
  {
    title: '1. Đăng ký vay',
    icon: <ProcessIconOne />,
    description:
      'Khách hàng đăng ký vay qua chức năng Vay vốn trên web/app KiotViet quản lý',
  },
  {
    icon: <ProcessIconTwo />,
    title: '2. Thẩm định hồ sơ',
    description:
      'Tiến hành thẩm định hồ sơ theo thông tin đăng ký và dữ liệu kinh doanh',
  },
  {
    icon: <ProcessIconThree />,
    title: '3. Ngân hàng phê duyệt và giải ngân',
    description:
      'Ngân hàng ưu tiên thẩm định cho khách hàng của KiotViet và giải ngân nhanh chóng',
  },
]

export default function Process({ loanApplyUrl }) {
  const { addEventAction } = useKva()
  const onClickProcessRegisterButton = () => {
    addEventAction(LANDING_PAGE_LENDING, 'click_button_register_process')
  }
  return (
    <div
      id="quy-trinh-vay"
      className="lg:my-[94px] mt-[60px] mb-10 flex justify-center "
    >
      <div className="max-w-[1920px]">
        <div className="flex flex-col items-center lg:gap-14 gap-10">
          <h2
            id="process-title"
            className="text-navy text-center lg:text-[30px] text-6 font-bold max-md:px-4"
          >
            Quy trình đăng ký vay chỉ 5 phút
          </h2>
          <div className="flex md:flex-row flex-col gap-6 items-center ">
            {PROCESS_LIST.map(process => {
              return (
                <div
                  key={process.title}
                  className="flex bg-white text-center items-center shadow-light-shadow rounded-[20px] flex-col p-6 gap-6 lg:h-[226px] md:h-[350px] h-fit lg:w-[384px] md:w-[219px] w-[343px]"
                >
                  <div className="flex items-center ">{process.icon}</div>
                  <div className="flex flex-col justify-center gap-2">
                    <div className="text-lg font-semibold leading-[26px] text-text-strong">
                      {process.title}
                    </div>
                    <div className="">
                      <div className="text-base font-normal text-text-strong self-stretch list-disc">
                        {process.description}
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
          <Link
            id="process-register-button"
            onClick={onClickProcessRegisterButton}
            className="
                h-[60px] px-8 py-4 text-xl font-bold
                shadow-register-button w-fit bg-brand-primary-500 hover:bg-brand-primary-600 active:bg-brand-primary-700 rounded-[99px] justify-center items-center gap-2 inline-flex cursor-pointer
                font-[Inter] text-white leading-[27px] text-center text-decoration-none	
            "
            target="_blank"
            href={loanApplyUrl || '#'}
          >
            Đăng ký vay
          </Link>
        </div>
      </div>
    </div>
  )
}
